import { VendorsState } from "../../../../types/vendors.types";

const selectVendorsIsFetching = ({ vendors }: { vendors: VendorsState }) =>
  vendors.isFetching;
const selectVendorsHasFetched = ({ vendors }: { vendors: VendorsState }) =>
  vendors.hasFetched;
const selectVendorsData = ({ vendors }: { vendors: VendorsState }) =>
  vendors.data?.vendors;

export { selectVendorsData, selectVendorsHasFetched, selectVendorsIsFetching };
